
















































































































































































import { Component, Prop } from "vue-property-decorator";
import Bases from "@/components/designer/sidebar/base/Base.vue";
import Finish from "@/components/designer/sidebar/frame/Finish.vue";
import { mixins } from "vue-class-component";
import { BaseStore, LayoutStore, ShapeStore } from "@/mixins/store";
import { GetFinishImage } from "@/mixins/helpers";
import { BaseModel } from "@/models/products/base";
import { Finish as FinishModel, FinishHandle } from "@/models/products/finish";
import ProductService from "@/services/product_service";
import UIkit from "uikit";
import { ProductListRes, ProductType } from "@/models/products/product";
import { Collection, ProductLineName } from "@/models/products/collection";
import { APIError, ViewerError } from "@/services/error_service";
import { Stem } from "@/models/configurator/configurator_options";

@Component({
  components: {
    Bases,
    Finish,
  },
})
export default class BaseSidebar extends mixins(
  BaseStore,
  LayoutStore,
  GetFinishImage,
  ShapeStore
) {
  @Prop() isStockOnly!: boolean;
  @Prop({ default: true }) hasVent!: boolean;
  @Prop({ default: true }) hasValance!: boolean;
  protected ProductLineName = ProductLineName;
  protected selectedBase: BaseModel | null = null;
  protected selectedFinish: FinishModel | null = null;
  protected baseData: null | Collection[] = null;
  protected productService = new ProductService();
  protected FinishHandle = FinishHandle;
  protected selectedStem: Stem | null = null;
  protected Stem = Stem;
  protected filteredBases = [
    "50C",
    "BZ-SM",
    "BZ2-SM",
    "8ST",
    "18ST",
    "36G-SQx2",
    "XB",
    "XB+C",
    "NGU550-E",
    "38SAP-2",
  ]; // hide these bases

  async mounted() {
    const loader = this.$loading.show({
      isFullPage: false,
      container: this.$refs.spinnerContainer,
    });
    const data = await this.getBases(loader);
    if (!this.collection.specific_mounting) {
      this.baseData = data! as Collection[];
    } else {
      this.baseData = [
        {
          type: ProductType.Base,
          _id: "1",
          display_name: `${this.collection.display_name} bases & mounts`,
          handle: this.collection.handle,
          models: data! as BaseModel[],
        },
      ] as Collection[];
    }
    this.baseBusinessLogic();
    this.readStoreData();
  }

  /** Specific logic to override base display on specific product lines */
  protected baseBusinessLogic(): void {
    if (this.collection.handle === ProductLineName.Catalina) {
      const availableBasesCatalina = {
        handle: "galvanized_steel_plate",
        models: ["20G-SQ", "24G-SQ", "24G", "30G"],
      };
      this.baseData = this.baseData!.map((base) => {
        if (base.handle === availableBasesCatalina.handle) {
          base.models = (base.models as BaseModel[]).filter((b: BaseModel) => {
            if (availableBasesCatalina.models.includes(b.model)) {
              return b;
            }
          }) as BaseModel[];
          return base as Collection;
        } else {
          return base as Collection;
        }
      });
    }
  }

  protected async clearBase(): Promise<void> {
    this.addBase(null);
    this.addBaseFinish(null);
    this.addBaseStem(null);
    this.addBaseOptions(null);
    this.selectedBase = null;
    this.selectedFinish = null;
    this.selectedStem = null;
    await this.$viewer.ChangeBase(null);
  }

  /**
   * Check the store for preset data. If there is none, set default
   * selected model to the first one in model array
   */
  protected readStoreData(): void {
    this.selectedBase = this.baseModel;
    this.selectedFinish = this.baseFinish;
    this.selectedStem = this.baseStem;
    // this.sendToViewer();
  }

  protected setDefaultStem(model: BaseModel): void {
    if (model.mounts && model.mounts.length > 0) {
      this.addBaseStem(Stem.Stem8ST);
      this.selectedStem = Stem.Stem8ST;
    } else {
      this.addBaseStem(null);
    }
  }

  protected setDefaultFinish(model: BaseModel): void {
    const finish = model.finishes[0] ? model.finishes[0] : null;
    this.selectedFinish = finish;
    this.addBaseFinish(finish);
  }

  protected async getBases(
    loader?: any
  ): Promise<Collection[] | BaseModel[] | undefined> {
    let bases;
    let res: ProductListRes;
    try {
      if (this.collection.specific_mounting) {
        bases = [] as BaseModel[];
        res = await this.productService.getBases(this.umbrellaModel?.model);
        bases = (res.data! as any).bases as BaseModel[];
        bases = bases.filter(
          (model) => !this.filteredBases.includes(model.model)
        );
      } else {
        bases = [] as Collection[];
        res = await this.productService.getBases();
        bases = res.data!.filter(
          (pl: any) =>
            pl.type === ProductType.Base &&
            pl.handle !== "aluminum_shell" &&
            pl.handle !== "specialty" &&
            pl.handle !== "in_ground_direct_mount"
        );
        for (const [i, pl] of (bases as Collection[]).entries()) {
          let models: BaseModel[] = [...pl.models] as BaseModel[];
          models = models.filter(
            (model) =>
              !model.is_umbrella_specific &&
              !this.filteredBases.includes(model.model)
          );
          (bases as Collection[])[i].models = models;
        }
      }
      if (loader) {
        loader.hide();
      }
    } catch (err) {
      if (err instanceof APIError) {
        APIError.popup(err.message, err.statusCode);
      }
    }
    return bases;
  }

  protected selectBase(
    model: BaseModel,
    finish: FinishModel | null = null,
    stem: Stem | null = null
  ): void {
    if (!stem) {
      this.setDefaultStem(model);
    } else {
      this.selectedStem = stem;
      this.addBaseStem(stem);
    }
    if (!finish || !model.finishes.includes(finish)) {
      this.setDefaultFinish(model);
    } else {
      this.selectedFinish = finish;
      this.addBaseFinish(finish);
    }
    this.selectedBase = model;
    this.addBase(model);
    this.sendToViewer();
  }

  protected async sendToViewer(): Promise<void> {
    let base;
    //Certain base+18ST2 combinations are a separate product with no stem attribute. Detect these bases and set selectedStem to 18ST2 & trim from model name (this is how the viewer accepts this data)
    if (
      this.selectedBase!.model &&
      this.selectedBase!.model !== Stem.Stem18ST2 &&
      this.selectedBase!.model.indexOf("18ST2") > -1
    ) {
      base = this.selectedBase!.model.slice(0, -6);
      this.selectedStem = Stem.Stem18ST2;
    } else if (!this.selectedBase!.model) {
      base = null;
    } else {
      base = this.selectedBase!.model;
    }
    try {
      if (this.selectedBase) {
        await this.$viewer.ChangeBase(
          base,
          this.selectedFinish
            ? this.selectedFinish.handle
            : this.selectedBase!.finishes[0].handle,
          this.selectedStem ? this.selectedStem : Stem.Stem8ST // if base does not have specific stems, send in 8ST, but app state will still be null. Viewer will not reset stem height if null.
        );
      }
    } catch (err) {
      ViewerError.redirect(err);
    }
  }

  protected toggleBaseModal(id: string): void {
    UIkit.modal(document.getElementById(id) as HTMLElement).show();
  }
}
